export default [
    {
        id: "01",
        text: "AEON"
    },
    {
        id: "02",
        text: "KVYNN"
    }
]